import { animate, query, stagger, state, style, transition, trigger } from "@angular/animations";

export const showAnimation = trigger('show', [
    state('void', style({
        opacity: 0,
        transform: 'scale(.9)'
    })),
    state('*', style({
        opacity: 1,
        transform: 'scale(1)'
    })),
    transition('void => *', [
        animate('.2s ease-out')
    ])
]);

export const hideAnimation = trigger('hide', [
    state('void', style({
        opacity: 0
    })),
    state('*', style({
        opacity: 1
    })),
    transition('* => void', [
        animate('.5s ease-out')
    ])
]);

export const slideInAnimation = trigger('slideIn', [
    state('void', style({
        opacity: 0,
        width: 0
    })),
    state('*', style({
        opacity: 1,
        width: '*'
    })),
    transition('void => *', [
        animate('.4s ease-out')
    ])
]);

export const fadeAnimation = trigger('fade', [
    transition('void => *', [
        style({ opacity: 0 }),
        animate(1000, style({ opacity: 1 }))
    ])
]);

export const listAnimation = trigger('list', [
    transition('* => *', [ // each time the binding value changes
        query(':enter', [
            style({ opacity: 0 }),
            stagger(100, [
                animate('0.5s', style({ opacity: 1 }))
            ])
        ], { optional: true })
    ])
]);
